// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-calendar {
  width: 100%;
  max-width: calc(100vw - 40px);
  border-radius: 12px;
  border-color: #d8d8ff;
}

.react-calendar__navigation__label {
  font-size: 16px;
  font-weight: 400;
  color: #00007a;
}
.react-calendar__navigation__label:hover {
  background: none !important;
}

.react-calendar__navigation__arrow {
  font-size: 26px;
  font-weight: 400;
  color: #00007a;
  padding-bottom: 10px;
  background: none !important;
}
.react-calendar__navigation__arrow:disabled {
  visibility: hidden;
}

.react-calendar__navigation__prev2-button,
.react-calendar__navigation__next2-button {
  visibility: hidden;
}

.react-calendar__month-view__weekdays__weekday abbr {
  font-size: 14px;
  font-weight: 300;
  color: #00007a;
  text-decoration: none;
  text-transform: capitalize;
}

.react-calendar__tile {
  font-size: 14px;
  font-weight: 300;
  color: #00007a;
  background: none !important;
}
.react-calendar__tile:disabled {
  color: #d8d8ff;
}
.react-calendar__tile:enabled:hover abbr {
  background-color: #d8d8ff;
}
.react-calendar__tile abbr {
  padding: 3px 7px;
  border-radius: 16px;
}

.react-calendar__tile--active abbr {
  color: #FFF;
  background-color: #00007a !important;
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Activation/Calendar.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,qBCLO;ADUX;;AADA;EACI,eAAA;EACA,gBAAA;EACA,cCNO;ADUX;AAFI;EACI,2BAAA;AAIR;;AACA;EACI,eAAA;EACA,gBAAA;EACA,cCjBO;EDkBP,oBAAA;EACA,2BAAA;AAEJ;AAAI;EACI,kBAAA;AAER;;AAIA;;EAEI,kBAAA;AADJ;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,cCpCO;EDqCP,qBAAA;EACA,0BAAA;AADJ;;AAMA;EACI,eAAA;EACA,gBAAA;EACA,cC9CO;ED+CP,2BAAA;AAHJ;AAKI;EACI,cCxDG;ADqDX;AAMI;EACI,yBC5DG;ADwDX;AAOI;EACI,gBAAA;EACA,mBAAA;AALR;;AAWI;EACI,WAAA;EACA,oCAAA;AARR","sourcesContent":["@use 'styles/colors.scss';\n\n.react-calendar{\n    width: 100%;\n    max-width: calc(100vw - 40px);\n    border-radius: 12px;\n    border-color: colors.$primary2;\n}\n\n// Selected month + year\n.react-calendar__navigation__label{\n    font-size: 16px;\n    font-weight: 400;\n    color: colors.$primary8;\n\n    &:hover{\n        background: none!important;\n    }\n}\n\n// Navigation\n.react-calendar__navigation__arrow{\n    font-size: 26px;\n    font-weight: 400;\n    color: colors.$primary8;\n    padding-bottom: 10px;\n    background: none!important;\n\n    &:disabled{\n        visibility: hidden;\n    }\n\n}\n\n// Next / prev year\n.react-calendar__navigation__prev2-button,\n.react-calendar__navigation__next2-button{\n    visibility: hidden;\n}\n\n.react-calendar__month-view__weekdays__weekday abbr{\n    font-size: 14px;\n    font-weight: 300;\n    color: colors.$primary8;\n    text-decoration: none;\n    text-transform: capitalize;\n}\n\n\n// Days\n.react-calendar__tile{\n    font-size: 14px;\n    font-weight: 300;\n    color: colors.$primary8;\n    background: none!important;\n\n    &:disabled{\n        color: colors.$primary2;\n    }\n\n    &:enabled:hover abbr{\n        background-color: colors.$primary2;\n    }\n\n    abbr{\n        padding: 3px 7px;\n        border-radius: 16px;\n    }\n}\n\n// Selected day\n.react-calendar__tile--active{\n    abbr{\n        color: #FFF;\n        background-color: colors.$primary8!important;\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`
};
export default ___CSS_LOADER_EXPORT___;
